import { render, staticRenderFns } from "./DashboardDireccion.vue?vue&type=template&id=3eec074d"
import script from "./DashboardDireccion.vue?vue&type=script&lang=js"
export * from "./DashboardDireccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports